import React from "react";
import TitleComponent from "@components/TitleComponent";
const FilterTitleComponent = ({ filter }) => {
  return <TitleComponent text={filter.name} description={filter.description} />;
};

export default FilterTitleComponent;
